import Fetch from "../../utils/Fetch";
import filtersToSearchParams from "../../utils/filtersToSearchParams";
import objectToFormData from "../../utils/ObjectToFormData";

export default {
    namespaced: true,
    state: {
        reviewsList: [],
		pagination: {
			total: 0,
			offset: 0,
			limit: 4,
		},
        products: [],
    },
    mutations: {
        setReviewsList(state, data) {
            state.reviewsList = data.items
			state.pagination.total = data.total
        },
		setPaginationOffset(state, offset) {
			state.pagination.offset = offset
		},
        setProducts(state, data) {
            state.products = data;
        },
    },
    actions: {
        async requestReviewsList({commit, state}) {
			commit('startLoading', 'requestReviewsList', {root: true})
			const response = await Fetch(`reviews/${filtersToSearchParams(null, state.pagination.offset, state.pagination.limit)}`, {
                method: 'GET',
            });

            if (response.success) {
                commit('setReviewsList', response.data)
            }

			commit('stopLoading', 'requestReviewsList', {root: true})
            return {
                ...response
            }
        },
		async requestAddReview({commit}, data) {
            commit('startLoading', 'requestAddReview', {root: true})

            const body = new objectToFormData(data);
            let response = await Fetch(`reviews/add/`, {
                method: 'POST',
                body
            });
			commit('stopLoading', 'requestAddReview', {root: true})
			return response;
		},
        async requestProducts({commit}) {
            commit('startLoading', 'requestProducts', {root: true});
            const response = await Fetch('reviews/fields/', {
                method: 'GET',
            });
            if (response.success) {
                commit('setProducts', response.data);
            }
            commit('stopLoading', 'requestProducts', {root: true});
            return response;
        },
    },
    getters: {
        getReviewsList: state => state.reviewsList,
        getPaginationTotal: state => state.pagination.total,
        getPaginationOffset: state => state.pagination.offset,
        getPaginationLimit: state => state.pagination.limit,
        getProducts: state => state.products,
    }
} 